import { render, staticRenderFns } from "./SuspensionsView.vue?vue&type=template&id=108a217a&"
import script from "./SuspensionsView.vue?vue&type=script&lang=js&"
export * from "./SuspensionsView.vue?vue&type=script&lang=js&"
import style0 from "./SuspensionsView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports